import axios from "axios";

export const WHATSAPP_SYSTEM_API_PATH = "/api/system/settings/whatsapp";

export const getSystemWhatsAppRegistrationTemplates = ({ signal } = {}) => axios.get(`${WHATSAPP_SYSTEM_API_PATH}/registration-templates`, { signal });
export const putSystemWhatsAppRegistrationTemplates = (templates) => axios.put(`${WHATSAPP_SYSTEM_API_PATH}/registration-templates`, { templates });

export function getSystemWhatsAppTemplates({ signal, synchronize = false } = {}) {
  return axios.get(`${WHATSAPP_SYSTEM_API_PATH}/templates`, {
    signal,
    ...(synchronize ? { params: { synchronize: "1" } } : {}),
  });
}

export function getSystemWhatsAppTemplateVersion(templateId, templateVersion, { signal } = {}) {
  return axios.get(
    `${WHATSAPP_SYSTEM_API_PATH}/templates/${encodeURIComponent(templateId)}/versions/${encodeURIComponent(templateVersion)}`,
    { signal },
  );
}

export function deleteSystemWhatsAppMetaTemplate({ templateId, catalogId, templateVersion }) {
  return axios.post(`${WHATSAPP_SYSTEM_API_PATH}/templates/delete-meta`, {
    ...(templateId ? { template_id: templateId } : {}),
    ...(catalogId ? { catalog_id: catalogId } : {}),
    ...(templateVersion != null ? { template_version: templateVersion } : {}),
  });
}

export function disconnectSystemWhatsAppSender(senderId) {
  return axios.delete(`${WHATSAPP_SYSTEM_API_PATH}/senders/${encodeURIComponent(senderId)}`);
}

export function synchronizeSystemWhatsAppSender(senderId, { subscribeWebhook = false } = {}) {
  return axios.post(
    `${WHATSAPP_SYSTEM_API_PATH}/senders/${encodeURIComponent(senderId)}/sync`,
    { subscribe_webhook: subscribeWebhook === true },
  );
}

export function createSystemWhatsAppTemplate(payload) {
  return axios.post(`${WHATSAPP_SYSTEM_API_PATH}/templates`, payload);
}

export function updateSystemWhatsAppTemplate({ templateId, payload }) {
  return axios.put(
    `${WHATSAPP_SYSTEM_API_PATH}/templates/${encodeURIComponent(templateId)}`,
    payload,
  );
}

export function submitSystemWhatsAppTemplate(templateId, activeVersion) {
  return axios.post(
    `${WHATSAPP_SYSTEM_API_PATH}/templates/${encodeURIComponent(templateId)}/submit`,
    { active_version: activeVersion },
  );
}

export function syncSystemWhatsAppTemplate(templateId) {
  return axios.post(
    `${WHATSAPP_SYSTEM_API_PATH}/templates/${encodeURIComponent(templateId)}/sync`,
  );
}

export function recoverSystemWhatsAppTemplateSubmission(templateId) {
  return axios.post(
    `${WHATSAPP_SYSTEM_API_PATH}/templates/${encodeURIComponent(templateId)}/recover`,
  );
}
